import React from 'react';

export const LOD = props => {
  return (
    props.zoom > props.floor &&
    props.zoom < props.ceiling && <>{props.children}</>
  );
};
